export const publicUploadPath = '/uploads';
export const publishResizedImagePath = '/resized';
//# sourceMappingURL=ServerPaths.js.map